//
//  SDKDocsBlockStorybookProperty.ts
//  Supernova SDK
//
//  Created by Supernova.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Storybook property - Definition */
export class DocsBlockStorybookPropertyDefinition extends DocsBlockPropertyDefinition {
}
